<div class="check-ip-wrapper">
  <div class="check-ip-content">
    <div class="section-title">
      <div>Выводы на кошелек: {{wallet}}
      </div>

      <div>
        <button mat-stroked-button color="warn" (click)="blockAllUsersByWallet()">Заблокировать вывод всем с этого
          Кошелька
        </button>
      </div>
    </div>


    <div class="check-ip-data">
      <div class="check-ip-table mat-elevation-z8">


        <table class="" mat-table [dataSource]="checkWallet" matSort>

          <!-- id Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
            <td mat-cell *matCellDef="let row"> {{row.id}}</td>
          </ng-container>

          <!-- date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Регистрация</th>
            <td mat-cell *matCellDef="let row">{{row.date | date: 'dd.MM.yy HH:mm'}} </td>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Имя</th>
            <td mat-cell *matCellDef="let row"><a [routerLink]="['/user/', row.user_id]">{{row.name}}</a>
            </td>
          </ng-container>

          <!-- is_locked Column -->
          <ng-container matColumnDef="is_locked">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Заблокирован</th>
            <td mat-cell *matCellDef="let row">{{row.is_locked ? 'Да' : 'Нет'}} </td>
          </ng-container>

          <!-- points Column -->
          <ng-container matColumnDef="points">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Сумма</th>
            <td mat-cell *matCellDef="let row"> {{row.points / 100 | currency: 'USD'}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="checkWalletColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: checkWalletColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td *ngIf="!isLoading" class="mat-cell empty-data" colspan="5">Данные отсутствуют</td>
          </tr>
        </table>

        <div *ngIf="isLoading" class="spinner-container">
          <mat-progress-spinner
            [diameter]="30"
            color="primary"
            mode="indeterminate">
          </mat-progress-spinner>
        </div>


        <mat-paginator [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
